import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import { envAwarePost } from "../../util/util"
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch';
import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";
import { getAllPosts, selectAllPosts, getPostById, deletePost, requestOfficialBlog, getPageAddress } from "../../state/blogSlice";
import CenteredLoader from "../CenteredLoader/CenteredLoader"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import BlogAddEdit from "./BlogAddEdit";
import "./styles.css"
import styles from './Blog.module.css'
import useCurrentUser from '../../hooks/useCurrentUser'

function Blog() {
    //const pageAddress = useSelector(state => state.users.current_user.bio_data.pageAddress)
    const postListLoading = useSelector(state => state.posts.postListLoading);
    const postList = useSelector(selectAllPosts);
    const [sortedPosts, setSortedPosts] = useState([]);
    const [pageAddress, setPageAddress] = useState("");

    const [showAddEditModal, setShowAddEditModal] = useState(false);
    const [postData, setPostData] = useState({});
    const [editPostLoading, setEditPostLoading] = useState(false)
    const [type, setType] = useState("");

    let dispatch = useDispatch();
    let statusDispatch = useApiStatusDispatch();

    const user = useCurrentUser()
    const pageTypeText = (
        user.account_type === 'gym' 
        ? 'Gym' 
        : 'trainer'
    )

    useEffect(() => {
        dispatch(getAllPosts())
        dispatch(getPageAddress())
            .then( res => {
                setPageAddress(res.payload.data.pageAddress)
                //console.log(res)
            })
    }, [])

    useEffect(() => {
        let sorted = postList.sort((a, b) => {
            let bdate = new Date(b.date_added?.split(' ').join('T'));
            let adate = new Date(a.date_added?.split(' ').join('T'));

            if (isNaN(adate)) {
                return -1
            }
            if (isNaN(bdate)) {
                return 1
            }
            return bdate - adate;
        })
        //console.log(sorted)
        setSortedPosts(sorted);
    }, [postList])



    function handleEditPost(post_id) {
        setType("edit")
        setShowAddEditModal(true)
        setEditPostLoading(true);
        const payload = {
            post_id: post_id,
            action: "getPostById"
        }
        dispatch(getPostById(payload))
            .then(res => {
                setEditPostLoading(false);
                setPostData(res.payload.data)
            })
    }

    function handleCreatePost() {
        setType("create")
        setShowAddEditModal(true)
    }

    return (
        <div className={['pt-2 px-2 px-md-3',styles.blogContainer].join(' ')} id="containerDiv">
            <strong className="display-8" style={{lineHeight:'1.5'}}> Manage Blogs </strong>
            <div className="d-block d-md-none">
                {pageAddress?.length > 0 ? 
                    <span> Your blog link:&nbsp;
                        <Link to={`/${pageAddress}/blog`}><b>{`www.fitsw.com/${pageAddress}/blog`}</b></Link> - edit it on
                        <Link to="/profile/"><b> your Profile page</b></Link>. 
                    </span> 
                    :
                    <span>
                        Get started with your {pageTypeText} Page on
                        <Link to="/profile/"><b> your profile </b></Link>
                        under the "Page Address" section.&nbsp;
                    </span>
                }
            </div>
            <div className="d-none d-md-block">
                {pageAddress?.length > 0 ? <span> You can share your blog with others by using this web address:&nbsp;
                    <Link to={`/${pageAddress}/blog`}><b>{`www.fitsw.com/${pageAddress}/blog`}</b></Link>.
                    You can change this web address by going to
                    <Link to="/profile/"><b> your Profile page </b></Link>
                    and updating "Page Address". </span> :
                    <span>
                        You can share your blog with others by creating your {pageTypeText} Page on
                        <Link to="/profile/"><b> your profile </b></Link>
                        under the "Page Address" section.&nbsp;
                    </span>}
                <span>
                    Your clients will automatically have a link to your
                    blog in their FitSW menu. When posting, you can choose
                    who can view your posts: clients only or everyone.
                </span>
            </div>

            <hr className="mt-0 mb-4"></hr>
            {/* <div className="text-center">
                <Button variant="outline-success"
                    onClick={() => handleCreatePost()}
                    className="mb-2 mr-2">
                    <i class="fas fa-plus"></i> Create Blog
                </Button>
                <Link to={`/${pageAddress}/blog/`}>
                    <Button variant="outline-primary"
                        className="mb-2 mr-2">
                        Live Blog Page
                    </Button>
                </Link>
            </div > */}
            { !showAddEditModal ? <div style={{ 
                // backgroundColor: "#f7f8f9",
                // padding: "20px", 
                // boxShadow: "0 0 12px -5px rgb(0 0 0 / 40%)", 
                borderRadius: "5px", 
                }}>
                <div style={{display:'flex', justifyContent:'flex-end'}}>
                    <Button variant="outline-success"
                        onClick={() => handleCreatePost()}
                        className="mb-2 mr-2">
                        <i class="fas fa-plus"></i> Create Blog
                    </Button>
                    <Link to={`/${pageAddress}/blog/`}>
                        <Button variant="outline-primary"
                            className="mb-2 mr-2">
                            Live Blog Page
                        </Button>
                    </Link>
                </div >
                {postListLoading ?
                    <CenteredLoader /> :
                    // <Table bordered className="blogsTable">
                    <Table bordered size="sm">
                        <thead style={{ backgroundColor: "#172B4D", color: "#fff" }}>
                            <tr>
                                <th >Title</th>
                                <th>Viewable by</th>
                                <th>Published</th>
                                <th className="text-center">Options</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sortedPosts?.map(post => {
                                return (
                                    <tr key={post.post_id} >
                                        <td>
                                            <a style={{ cursor: "pointer" }} className="text-primary"
                                                onClick={() => handleEditPost(post.post_id)}>
                                                {post.post_title}
                                            </a>
                                            <small className="d-block text-info">
                                                {post.total_num_comments} comments
                                            </small>
                                        </td>
                                        <td>{post.is_public === "1" ? "Everyone" : "Clients Only"}</td>
                                        <td> {post.is_active === "1" ? <span> {post.date_added} </span> :
                                            <span className="text-danger"> (draft)  </span>} </td>
                                        <td class="text-center">
                                            {post.is_active === "1" && <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id="fitswBlogRequest">
                                                        View Post On Live Blog Page
                                                    </Tooltip>
                                                }
                                            >
                                                <Link to={`/${pageAddress}/blog/${post.post_slug}/`}
                                                    class="align-middle text-center">
                                                    <Button
                                                        size="sm" className="m-1" variant={"outline-primary"}>
                                                        <span className="fa fa-eye "></span>
                                                    </Button>
                                                </Link>
                                            </OverlayTrigger>}


                                            {post.is_active === "1" && <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id="fitswBlogRequest">
                                                        Request to post on the official FitSW blog.
                                                    </Tooltip>
                                                }
                                            >
                                                <Button
                                                    size="sm"
                                                    variant="outline-primary"
                                                    className="m-1"
                                                    onClick={() => {
                                                        if (post.is_public !== "1") {
                                                            alert('Only public posts can be shared to the FitSW Blog.');
                                                            return;
                                                        }
                                                        let post_link = `https://www.fitsw.com/${pageAddress}/blog/${post.post_slug}/`

                                                        let payload = {
                                                            post_title: post.post_title,
                                                            post_link,
                                                            action: "requestOfficialBlog"
                                                        }
                                                        if (window.confirm("Send request to make into official blog?")) {
                                                            statusDispatch(requestOfficialBlog(payload), "official blog", "request")
                                                        }

                                                    }}
                                                >
                                                    <span className="fas fa-globe"></span></Button>
                                            </OverlayTrigger>
                                            }

                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id="fitswBlogRequest">
                                                        Delete Blog
                                                    </Tooltip>
                                                }
                                            >
                                                <Button
                                                    size="sm"
                                                    variant={"outline-danger"}
                                                    className="m-1"
                                                    onClick={() => {
                                                        let post_id = post.post_id;
                                                        let payload = {
                                                            post_id,
                                                            action: "deletePost"
                                                        }
                                                        if (window.confirm("are you sure you want to delete this blog?")) {
                                                            statusDispatch(deletePost(payload), "blog", "delete")
                                                        }
                                                    }}>
                                                    <span className="fas fa-times fa-lg"></span>
                                                </Button>
                                            </OverlayTrigger>

                                        </td>

                                    </tr>)
                            })
                            }
                        </tbody>
                    </Table>
                }
            </div> :
            <BlogAddEdit
                editPostLoading={editPostLoading}
                postData={postData}
                setShowAddEditModal={setShowAddEditModal}
                showAddEditModal={showAddEditModal}
                type={type}
            />}

        </div >
    )
}

export default Blog;